import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['noteField'];

  connect() {
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
  }

  handleSubmitEnd(event) {
    if (event.detail.success) {
      this.closeQuickLook(event);
    } else
    {

      // find error-panel and show it
        const errorPanel = this.element.querySelector("#error-panel");
        if (errorPanel) {
          errorPanel.classList.remove("u-hidden");
        }
    }
  }
  async showQuickLook(event) {
    event.preventDefault();

    const quickViewElement = document.querySelector("#driving-school-fee-quick-look");
    quickViewElement.classList.remove("u-hidden");
  }

  closeQuickLook(event) {
    event.preventDefault();

    const quickViewElement = document.querySelector("#driving-school-fee-quick-look");
    quickViewElement.classList.add("u-hidden");
  }


}